import React from 'react';
// Optional: Import an SVG or image for a visual representation
// import { ReactComponent as EmptyBox } from '../../../images/svg/empty-box.svg';

const CBEmpty = ({ description = 'No Data' }) => {
  return (
    <div className="flex flex-col items-center justify-center p-8 text-center text-gray-500">
      {/* Optional: Visual element */}
      {/* <EmptyBox className="w-16 h-16 mb-4 text-gray-300" /> */}
      <svg className="w-16 h-16 mb-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" /></svg>
      <p>{description}</p>
    </div>
  );
};

export { CBEmpty };